export function updateShortDescriptionBox() {
  const loadMoreBtn = document.getElementById('loadMore');
  const browseBox = document.querySelector('.postBody');

  if (loadMoreBtn && browseBox) {
    const p = browseBox.querySelectorAll('.postBody > *');
    const width = window.innerWidth;

    if ((p.length < 3 && width > 767) || (p.length < 1 && width < 768)) {
      loadMoreBtn.style.display = 'none';
    }

    let isExpanded = false;
    const selector =
      width > 767
        ? '.postBody > *:nth-child(n+4)'
        : '.postBody > *:nth-child(n+2)';

    loadMoreBtn.addEventListener('click', () => {
      isExpanded = !isExpanded;

      if (isExpanded) {
        browseBox.querySelectorAll('.postBody > *').forEach((p) => {
          p.style.display = 'block';
        });
      } else {
        browseBox.querySelectorAll(selector).forEach((p) => {
          p.style.display = 'none';
        });
      }
    });
  }
}
